<template>
  <div class="modal fade create-new-user-modal" id="CreateServiceModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Criar serviço</h1>
                  <button type="button" class="btn-close create-new-user-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formCreateUser" @submit.prevent="createServiceMethod" class="d-flex flex-column overflow-hidden" style="min-height: 0;">
                <div class="modal-body ps-30 pe-30" style="overflow-y: auto; max-height: calc(100vh - 220px);">
                  <p>Preencha as informações abaixo para criar um serviço</p>
                  
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="name_service_created" class="form-label fw-medium"
                      >Serviço</label
                    >
                    <input
                      type="text"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="name_service_created"
                      placeholder="Digite o serviço"
                      autocomplete="off"
                      required
                    />
                  </div>
                  
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="category_service_created" class="form-label fw-medium"
                      >Categoria</label
                    >

                    <select id="category_service_created" v-model="selectedCategory" class="form-select">
                      <option disabled value="">Selecione a categoria</option>
                      <option v-for="cat in getCategories" :key="cat.id" :value="cat.id">
                        {{ cat.name }}
                      </option>
                    </select>
                  </div>

                  <div v-if="availableSubcategories.length" class="mb-15 mb-md-20 col-12 mt-30">
                    <label for="subcategory_service_created" class="form-label fw-medium">Subcategoria</label>
                    <select id="subcategory_service_created" v-model="selectedSubcategory" class="form-select" required>
                      <option disabled value="">Selecione a subcategoria</option>
                      <option v-for="subcategory in availableSubcategories" :key="subcategory.id" :value="subcategory.id">
                        {{ subcategory.name }}
                      </option>
                    </select>
                  </div>


                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="service_value" class="form-label fw-medium"
                      >Valor</label
                    >
                      <input
                        v-model="service_value"
                        type="text"
                        class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                        id="service_value"
                        autocomplete="off"
                        @input="maskMoney"
                        placeholder="Exemplo: 1.150,00"
                        required
                      />
                  </div>

                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="name_service_created" class="form-label fw-medium"
                      >Tempo de execução do serviço</label
                    >
                    <input
                      type="text"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="service_time"
                      placeholder="HH:MM"
                      @input="maskTime"
                      v-model="service_time"
                      maxlength="5"
                      autocomplete="off"
                      required
                    />
                  </div>

                  <div class="mb-20 col-12">
                    <label class="form-label fw-medium">Usuários que prestam este serviço</label>

                    <div v-if="availableUsers.length" class="border rounded-2 p-15" style="max-height: 260px; overflow-y: auto;">
                      <div
                        v-for="user in availableUsers"
                        :key="user.id"
                        class="form-check mb-12"
                      >
                        <input
                          :id="`create-service-user-${user.id}`"
                          v-model="selectedUserIds"
                          :value="user.id"
                          class="form-check-input"
                          type="checkbox"
                        />
                        <label class="form-check-label d-block" :for="`create-service-user-${user.id}`">
                          <span class="fw-medium text-black-emphasis">{{ user.name }}</span>
                          <small class="d-block text-body-tertiary">{{ user.email || user.phone || 'Sem contato cadastrado' }}</small>
                        </label>
                      </div>
                    </div>

                    <div v-else class="border rounded-2 p-15 text-body-tertiary">
                      Nenhum usuário disponível para vincular.
                    </div>
                  </div>

                  <div class="mb-15 mb-md-20 col-12 mt-30">
                    <label for="price_type_created" class="form-label fw-medium">Tipo do valor</label>
                    <select id="price_type_created" v-model="price_type" class="form-select">
                      <option value="FIXED">Valor fixo</option>
                      <option value="STARTING_AT">A partir de</option>
                    </select>
                  </div>

                  <DepositConfigurationForm v-model="deposit_configuration" :price-type="price_type" :users="availableUsers" :user-ids="selectedUserIds" />

                  <div class="col-12">
                    <div id="alertResponseApiCreateService" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageCreateService">
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger create-new-user-modal" data-bs-dismiss="modal">Cancelar</button>
                  <button type="submit" ref="buttonCreateService" class="btn btn-success">Criar serviço</button>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import api from '../../config/axios.js';
import DepositConfigurationForm from './DepositConfigurationForm.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: { DepositConfigurationForm },
  name: "CreateServiceModal",
  data () {
    return {
      currentAcces: 2,
      deposit_configuration: null,
      selectedOperations: [],
      selectedCategory: "",
      selectedSubcategory: "",
      price_type: "FIXED",
      service_value: null,
      service_time: "",
      selectedUserIds: []
    }
  },
  computed: {
    ...mapGetters([
      "getRolesList",
      "getOperations",
      "getCategories",
      "getSubcategories",
      "getServices",
      "getAllUsersList"
    ]),
    availableUsers() {
      const allUsersList = this.getAllUsersList;
      return Array.isArray(allUsersList) ? allUsersList : [];
    },
    availableSubcategories() {
      return (this.getSubcategories || []).filter(
        (subcategory) => String(subcategory.category_id) === String(this.selectedCategory)
      );
    }
  },
  watch: {
    async selectedCategory(categoryId) {
      this.selectedSubcategory = "";
      if (!categoryId) return;
      await this.fetchSubcategories({ category_id: categoryId, active_only: true });
    }
  },
  methods: {
    ...mapActions([
      "fetchUsersByCategory",
      "fetchSubcategories"
    ]),
    maskTime() {
      let value = this.service_time.replace(/\D/g, '');

      // Limita a 4 números (HHMM)
      value = value.slice(0, 4);

      let hours = value.slice(0, 2);
      let minutes = value.slice(2, 4);

      if (hours.length === 2 && parseInt(hours) > 23) {
        hours = '23';
      }

      if (minutes.length === 2 && parseInt(minutes) > 59) {
        minutes = '59';
      }

      if (value.length > 2) {
        this.service_time = `${hours}:${minutes}`;
      } else {
        this.service_time = hours;
      }
    },
    maskMoney(e) {
      let value = e.target.value;

      value = value.replace(/\D/g, "");

      if (!value) {
        this.service_value = "";
        return;
      }

      value = (parseInt(value, 10) / 100).toFixed(2);

      value = new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);

      this.service_value = value;
    },
    changeInformationInputs(element){
      this.$refs[element].style.borderColor = "#dedee4";
    },
    applyMaskPhone(event) {
      const input = event.target;
      let value = input.value.replace(/\D/g, '');

      if (value.length > 10) {
        value = value.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        value = value.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }

      input.value = value;
    },
    checkPassword(password){
      return /[0-9]/.test(password) && /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>?]/.test(password);
    },
    createServiceMethod(){
      const alertResponse = this.alertResponse;

      const name_service_created = document.getElementById("name_service_created").value;
      const category_service_created = document.getElementById("category_service_created").value;
      const service_value = this.service_value;
      const service_time = document.getElementById("service_time").value;
      const user_ids = this.selectedUserIds;
      let error = false;

      if(
        name_service_created == "" ||
        category_service_created == "" ||
        service_value == "" ||
        service_time == ""
      ){
        this.alertResponse("Por favor preencha todos os campos", true);
        return;
      }

      if(name_service_created == ""){
        this.$refs.name_service_created.style.borderColor = "red";
        error = true;
      }

      if(error){
        return;
      }

      const objServiceCreate = {
        "service": name_service_created,
        "category_id": category_service_created,
        "subcategory_id": this.selectedSubcategory || null,
        "price_type": this.price_type,
        "deposit_configuration": this.deposit_configuration,
        "value": service_value,
        "time": this.service_time,
        "user_ids": user_ids
      }

      const buttonCreateService = this.$refs.buttonCreateService;
      buttonCreateService.disabled = true;
      buttonCreateService.innerHTML = "Criando usuário...";
      
      api.axios.post("/api/service/create", objServiceCreate).catch(function(error){
        if(error.response.data != undefined){
          buttonCreateService.innerHTML = "Criar serviço";
        }
        console.log("error", error);
        alertResponse(Object.values(error.response?.data?.errors || {}).flat()[0] || error.response?.data?.message || error.response?.data || 'Não foi possível salvar o serviço.', true);
      }).then(function(response){
        
        if(response != undefined && response.status == 200){
          buttonCreateService.innerHTML = "Serviço criado com sucesso !";
          window.location.reload();
        } else {
          buttonCreateService.disabled = false;
          buttonCreateService.innerHTML = "Criar serviço";
        }
      });
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageCreateService").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageCreateService").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiCreateService");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }

      const password = document.getElementById("password_user_delete");
      if(password){
        password.value = "";
      }
    },
  }
};
</script>
